export default "__VITE_ASSET__CNlYNDtk__"